<template>
  <v-container fluid class="px-5">
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <!-- SNACKBAR -->

    <v-dialog v-model="dialogDownload" width="300px" persistent>
      <v-card>
        <v-card-title class="pb-7">
          <span class="headline"> Tipo Estadística </span>
        </v-card-title>

        <v-card-text>
          <v-select
            v-model="selectedOption"
            :items="opcionesDescarga"
            dense
            label="Tipo Estadística
"
          >
          </v-select>
        </v-card-text>

        <v-card-actions class="px-5 pb-4 pt-0">
          <v-btn
            color="blue darken-1"
            text
            outlined
            @click="dialogDownload = false"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            dark
            :loading="loader"
            @click="downloadReporteEstadisticas"
            :disabled="!selectedOption"
          >
            Descargar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SHEET -->
    <v-bottom-sheet v-model="mostrarLinkWhatsapp">
      <v-sheet class="text-center" height="auto">
        <p class="py-3 mb-0 title">Los datos a enviar al cliente son:</p>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12" md="1">
              <v-text-field
                label="CODIGO"
                hint="ejemplo: +503"
                persistent-hint
                v-model="codigoSMS"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="TELEFONO"
                hint="Sin separadores"
                persistent-hint
                :value="numeroTelefono"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-textarea
                solo
                auto-grow
                rows="1"
                label="DATOS"
                v-model="mensajeLinkEncuesta"
              >
              </v-textarea>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn
                class="mt-6"
                color="success"
                target="_blanck"
                :href="getWhatsAppURL"
                @click="reenvioEncuesta"
              >
                Enviar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <v-row justify="space-between" align="center">
      <v-col cols="12">
        <h2 class="px-3">Estadísticas Encuesta por Operador</h2>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row align="center" justify="center" class="pt-4 pb-1">
      <v-col class="pt-0 pl-4" cols="12" md="2">
        <v-text-field
          class="text-xs-center"
          v-model="search"
          dense
          append-icon="search"
          label="Búsqueda"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="2" class="pt-0">
        <v-autocomplete
          v-model="selectedCartera"
          :items="list_cartera"
          item-text="nombre"
          item-value="nombre"
          label="Cartera"
          dense
          hide-details
        >
        </v-autocomplete>
      </v-col>
      <v-col class="pt-0" cols="12" md="2">
        <v-text-field
          v-model="fechaInicio"
          type="date"
          hide-details
          dense
          label="Desde"
          :max="new Date().toISOString().substr(0, 10)"
          clearable
        ></v-text-field>
      </v-col>
      <v-col class="pt-0" cols="12" md="2">
        <v-text-field
          v-model="fechaFin"
          type="date"
          dense
          hide-details
          label="Hasta"
          :max="new Date().toISOString().substr(0, 10)"
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="1" class="text-right pt-0">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="primary"
              dark
              :block="$vuetify.breakpoint.smAndDown"
              @click="listar"
            >
              Listar
            </v-btn>
          </template>
          <span>Listar</span>
        </v-tooltip>
      </v-col>
      <v-col class="pt-0" cols="12" md="1">
        <v-tooltip bottom color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="green"
              :block="$vuetify.breakpoint.smAndDown"
              dark
              @click="getReporte"
            >
              <v-icon>fas fa-file-download</v-icon>
            </v-btn>
          </template>
          <span>Descargar</span>
        </v-tooltip>
      </v-col>
      <v-col class="pt-0" cols="12" md="1">
        <v-tooltip bottom color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="green"
              :block="$vuetify.breakpoint.smAndDown"
              dark
              @click="dialogDownload = true"
            >
              <v-icon>fas fa-chart-pie</v-icon>
            </v-btn>
          </template>
          <span>Estadísticas</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row>
      <v-col cols="12">
        <v-stepper non-linear v-model="step">
          <v-stepper-header>
            <v-stepper-step editable step="1">
              Encuestas Contestadas ({{ totalContestadas }} /
              {{ totalEncuestas }})</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step editable step="2">
              Encuestas Sin Contestar ({{ totalSinContestar }} /
              {{ totalEncuestas }})</v-stepper-step
            >
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-data-table
                :headers="dynamicHeaderContestadas"
                :items="encuestasCompletadas"
                :loading="loader"
                item-value="cabinaId"
                loading-text="Listando Datos..."
                :custom-filter="customFilter"
                no-data-text="No se encontraron resultados..."
                :search="search"
                class="elevation-2"
              >
                <template v-slot:[`item.respuestas`]="{ item }">
                  <v-col cols="12" class="py-2">
                    <v-row
                      v-for="(respuesta, index) in item.respuestas"
                      :key="respuesta.preguntaId"
                    >
                      <v-col cols="12" class="pt-3 pb-0">
                        <span class="font-weight-bold">
                          {{ index + 1 }}. {{ respuesta.pregunta }}
                        </span>
                        {{ respuesta.respuesta }}
                      </v-col>
                      <v-col cols="12" v-if="!!respuesta.comentario">
                        <span class="font-weight-bold"> Comentario:</span>
                        <br />
                        {{ respuesta.comentario }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-slot:[`item.nombreUsuario`]="{ item }">
                  <span
                    class="font-weight-bold"
                    v-if="selectedCartera == 'SISA SEGUROS'"
                  >
                    {{ item.respuestas[0].nombreUsuario }}
                  </span>
                  <span class="font-weight-bold" v-else>
                    {{ item }}
                  </span>
                </template>

                <template v-slot:[`item.resultados`]="{ item }">
                  <v-chip
                    v-if="selectedCartera == 'SISA SEGUROS'"
                    :color="
                      checkResultadoEncuesta(item) == 'Positivo'
                        ? 'green'
                        : 'red'
                    "
                    dark
                  >
                    {{ checkResultadoEncuesta(item) }}
                  </v-chip>
                  <v-chip :color="true ? 'green' : 'red'" dark v-else>
                    {{ item }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-stepper-content>
          </v-stepper-items>
          <v-stepper-content step="2">
            <v-data-table
              :headers="dynamicHeaderSinContestar"
              :items="encuestasSinCompletar"
              :loading="loader"
              loading-text="Listando Datos..."
              no-data-text="No se encontraron resultados..."
              :search="search"
              class="elevation-2"
            >
              <template v-slot:[`item.rechazada`]="{ item }">
                <v-chip :color="getColorEstadoEncuesta(item)" dark>
                  {{ getEstadoEncuesta(item) }}
                </v-chip>
              </template>
              <template v-slot:[`item.motivoRechazo`]="{ item }">
                {{ item.motivoRechazo }}
              </template>
              <template v-slot:[`item.reenviar`]="{ item }">
                <v-btn @click="showReenvio(item)" color="primary"
                  >Link Encuesta</v-btn
                >
              </template>
            </v-data-table>
          </v-stepper-content>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";

export default {
  name: "HistorialEncuestasSISA",
  data() {
    return {
      dialogDownload: false,
      selectedOption: "POR CARTERA",
      opcionesDescarga: ["GENERAL", "POR CARTERA"],
      list_cartera: [],
      selectedCartera: "",
      step: 2,
      snack: false,
      totalEncuestas: 0,
      totalSinContestar: 0,
      totalContestadas: 0,
      mostrarLinkWhatsapp: false,
      numeroAsistencia: "",
      numeroTelefono: "",
      codigoSMS: "+503",
      mensajeLinkEncuesta: "",
      snackColor: "primary",
      snackTime: 4000,
      snackText: "Notification",
      loader: false,
      search: "",
      fechaInicio: new Date().toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      encuestasCompletadas: [],
      encuestasSinCompletar: [],
      reporteLlamadasPBX: [],
      headers: [
        {
          text: "Número Asistencia",
          value: "numeroAsistencia",
          width: 150,
          align: "center",
        },
        {
          text: "Usuario",
          value: "usuario",
          width: 150,
          align: "center",
        },
        {
          text: "Fecha",
          value: "fecha",
          width: 150,
          align: "center",
        },
        {
          text: "No Responde Llamada",
          value: "noRespondeLlamada",
          width: 120,
          align: "center",
          sortable: true,
        },
        {
          text: "Calificacion Ejecutivo",
          value: "calificacionEjecutivo",
          width: 120,
          align: "center",
          sortable: true,
        },
        {
          text: "Calificacion Servicio",
          value: "calificacionServicio",
          width: 120,
          align: "center",
          sortable: true,
        },
        {
          text: "Lleno Formulario Reclamo",
          value: "llenoFormularioReclamo",
          width: 120,
          align: "center",
          sortable: true,
        },
        {
          text: "Necesidad Resuelta",
          value: "resueltaNecesidad",
          width: 120,
          align: "center",
          sortable: true,
        },
        {
          text: "Quejas/Observaciones",
          value: "quejasObservaciones",
          width: 250,
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  mounted() {},
  created() {
    const today = new Date();
    const firstDayInMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.fechaInicio = firstDayInMonth.toISOString().substring(0, 10);

    this.listarComboBox();
  },
  computed: {
    getWhatsAppURL() {
      const whatsAppLink = `https://api.whatsapp.com/send?phone=${this.codigoSMS}${this.numeroTelefono}&text=`;

      return `${whatsAppLink}${encodeURIComponent(this.mensajeLinkEncuesta)}`;
    },
    dynamicHeaderSinContestar() {
      const headersSinContestar = [
        {
          text: "Número Asistencia",
          value: "numeroAsistencia",
          width: 150,
          align: "center",
        },
        {
          text: "Titular Poliza",
          value: "titularPoliza",
          align: "center",
        },
        {
          text: "Número Teléfono",
          value: "numeroTelefono",
          width: 150,
          align: "center",
        },
        {
          text: "Estado",
          value: "rechazada",
          width: 120,
          align: "center",
          sortable: false,
        },
        {
          text: "Comentario",
          value: "motivoRechazo",
          width: 250,
          align: "center",
          sortable: false,
        },
        {
          text: "Operador",
          value: "operador",
          width: 200,
          align: "center",
        },
        {
          text: "Último Envío",
          value: "ultimoEnvio",
          width: 120,
          align: "center",
        },
        {
          text: "Reenviar",
          value: "reenviar",
          align: "center",
        },
      ];

      if (this.selectedCartera == "SISA SEGUROS") {
        return headersSinContestar;
      } else {
        return this.headers;
      }
    },
    dynamicHeaderContestadas() {
      const contestadas = [
        {
          text: "Número Asistencia",
          value: "cabinaId",
          width: 200,
          align: "center",
        },
        {
          text: "Resultados",
          value: "resultados",
          width: 120,
          align: "center",
        },
        { text: "Respuestas", value: "respuestas", sortable: false },
        { text: "Usuario", value: "nombreUsuario", sortable: false },
      ];

      if (this.selectedCartera == "SISA SEGUROS") {
        return contestadas;
      } else {
        return this.headers;
      }
    },
  },
  watch: {
    selectedCartera(oldVal, newVal) {
      this.encuestasCompletadas = [];
      this.encuestasSinCompletar = [];
    },
  },
  methods: {
    checkResultadoEncuesta(item) {
      const total = item.respuestas.length;
      const totalMalas = item.respuestas.filter(
        (res) => res.comentario != null && res.comentario != ""
      ).length;
      return totalMalas >= total / 2 ? "Negativo" : "Positivo";
    },
    downloadReporteEstadisticas() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let formatted = [];
      this.loader = true;

      if (this.selectedOption == "GENERAL") {
        axios
          .get(
            `api/Encuestas/EstadisticasPorOperadorCompletas?inicio=${this.fechaInicio}&fin=${this.fechaFin}`,
            configuracion
          )
          .then((res) => {
            formatted = res.data.map((x) => {
              return {
                OPERADOR: x.operador,
                TOTAL_COMPLETADAS: x.totalCompletadas,
                TOTAL_NO_COMPLETADAS: x.totalNoCompletadas,
                "TOTAL ENCUESTAS": x.total,
                "COMPLETADAS (%)": x.porcentajeCompletadas + "%",
                "NO COMPLETADAS (%)": x.porcentajeNoCompletadas + "%",
              };
            });

            this.exportExcel(formatted);
          })
          .catch((err) => {
            console.error("Error", err);
          })
          .finally(() => {
            this.dialogDownload = false;
            this.loader = false;
          });
      } else {
        if (this.selectedCartera == "SISA SEGUROS") {
          axios
            .get(
              `api/Encuestas/EstadisticasPorOperadorV2?inicio=${this.fechaInicio}&fin=${this.fechaFin}`,
              configuracion
            )
            .then((res) => {
              formatted = res.data.map((x) => {
                return {
                  OPERADOR: x.operador,
                  POSITIVAS: x.positivas,
                  NEGATIVAS: x.negativas,
                  PENDIENTES: x.pendientes,
                  RECHAZADAS: x.rechazadas,
                  ENVIO_WHATSAPP: x.envioWhatsApp,
                  NO_CONTESTA: x.noContesta,
                  RECHAZADA_ENVIO_WHATSAPP: x.rechazadaEnvioWhatsApp,
                  NO_CONTESTA_ENVIO_WHATSAPP: x.noContestaEnvioWhatsApp,
                  TOTAL_CONTESTADAS: x.totalContestadas,
                  TOTAL_SIN_CONTESTAR: x.totalSinContestar,
                  TOTAL_ENCUESTAS: x.totalEncuestas,
                  PORCENTAJE_CONTESTADAS: x.porcentajeContestadas,
                  PORCENTAJE_SIN_CONTESTAR: x.porcentajeSinContestar,
                };
              });

              this.exportExcel(formatted);
            })
            .catch((err) => console.error(err))
            .finally(() => {
              this.dialogDownload = false;
              this.loader = false;
            });
        } else {
          axios
            .post(
              "api/Encuestas/EstadisticasPorOperador",
              {
                fechaInicio: this.fechaInicio,
                fechaFin: this.fechaFin,
                cartera: this.selectedCartera,
              },
              configuracion
            )
            .then((res) => {
              formatted = res.data.map((x) => {
                return {
                  OPERADOR: x.operador,
                  TOTAL_COMPLETADAS: x.totalCompletadas,
                  TOTAL_NO_COMPLETADAS: x.totalNoCompletadas,
                  "TOTAL ENCUESTAS": x.total,
                  "COMPLETADAS (%)": x.porcentajeCompletadas + "%",
                  "NO COMPLETADAS (%)": x.porcentajeNoCompletadas + "%",
                };
              });

              this.exportExcel(formatted);
            })
            .catch((err) => console.error(err))
            .finally(() => {
              this.dialogDownload = false;
              this.loader = false;
            });
        }
      }
    },
    exportExcel(info) {
      const data = XLSX.utils.json_to_sheet(info);
      const workbook = XLSX.utils.book_new();
      const helper =
        this.selectedOption == "GENERAL" ? "GENERAL" : this.selectedCartera;

      XLSX.utils.book_append_sheet(workbook, data, "Estadísticas Encuestas");

      const filename = `Estadísticas Encuestas Operador (${helper}) ${this.fechaInicio} a ${this.fechaFin}.xlsx`;
      XLSX.writeFile(workbook, filename);
    },
    listarComboBox() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Carteras/Activas", configuracion)
        .then((res) => {
          this.list_cartera = res.data;
          this.selectedCartera = this.list_cartera[0]?.nombre;
        })
        .catch((err) => console.error(err))
        .finally(() => {
          this.listar();
        });
    },
    getEstadoEncuesta(item) {
      if (!item) return null;

      if (item.rechazada && item.envioLink && !item.noContesta) {
        return "Rechazada (Envio Por whatsApp)";
      } else if (!item.rechazada && item.envioLink && item.noContesta) {
        return "No Contesta (Envio Por whatsApp)";
      } else if (item.rechazada) {
        return "Rechazada";
      } else if (item.envioLink) {
        return "Envio Por whatsApp";
      } else if (item.noContesta) {
        return "No Contesta";
      }

      return "Pendiente";
    },
    getColorEstadoEncuesta(item) {
      let estado = this.getEstadoEncuesta(item);

      if (estado == "Rechazada (Envio Por whatsApp)") {
        return "amber darken-3";
      } else if (estado == "No Contesta (Envio Por whatsApp)") {
        return "blue-grey darken-1";
      } else if (estado == "Rechazada") {
        return "red";
      } else if (estado == "Envio Por whatsApp") {
        return "green";
      } else if (estado == "No Contesta") {
        return "cyan darken-3";
      } else if (estado == "Pendiente") {
        return "primary";
      }
    },
    calcularPorcentaje(valor, total) {
      if (!valor || !total) return 0.0;
      return ((valor / total) * 100).toFixed(3);
    },
    getEstadisticasContestadas() {
      let encuestasNegativas = 0;
      let encuestasPositivas = 0;

      this.encuestasCompletadas.forEach((encuesta) => {});
      return {
        total: this.encuestasCompletadas.length,
        positivas: encuestasPositivas,
        negativas: encuestasNegativas,
      };
    },
    getEstadisticasSinContestar() {
      let rechazadas = 0;
      let pendientes = 0;
      let rechazadaEnvioLink = 0;
      let noContestaEnvioLink = 0;
      let envioLink = 0;
      let noContesta = 0;

      this.encuestasSinCompletar.forEach((encuesta) => {
        let estado = this.getEstadoEncuesta(encuesta);

        if (estado == "Rechazada (Envio Por whatsApp)") {
          rechazadaEnvioLink++;
        } else if (estado == "No Contesta (Envio Por whatsApp)") {
          noContestaEnvioLink++;
        } else if (estado == "Rechazada") {
          rechazadas++;
        } else if (estado == "Envio Por whatsApp") {
          envioLink++;
        } else if (estado == "No Contesta") {
          noContesta++;
        } else if (estado == "Pendiente") {
          pendientes++;
        }
      });

      return {
        total: this.encuestasSinCompletar.length,
        rechazadas: rechazadas,
        pendientes: pendientes,
        rechazadaEnvioLink: rechazadaEnvioLink,
        noContestaEnvioLink: noContestaEnvioLink,
        envioLink: envioLink,
        noContesta: noContesta,
      };
    },
    getReporte() {
      if (this.step == 1) {
        if (this.selectedCartera == "SISA SEGUROS") {
          this.downloadReporteEncuestasCompletadasSISA();
        } else {
          this.downloadReporteEncuestasCompletadas();
        }
      } else if (this.step == 2) {
        if (this.selectedCartera == "SISA SEGUROS") {
          this.downloadReporteEncuestasNoCompletadasSISA();
        } else {
          this.downloadReporteEncuestasNoCompletadas();
        }
      }
    },
    customFilter(value, search, item) {
      if (!search) return true;

      const searchTerm = search.toLowerCase();

      if (item.cabinaId.toLowerCase().includes(searchTerm)) {
        return true;
      }

      if (
        item.respuestas.some((respuesta) =>
          respuesta.nombreUsuario.toLowerCase().includes(searchTerm)
        )
      ) {
        return true;
      }

      return false;
    },

    reenvioEncuesta() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.numeroAsistencia == "" || this.numeroAsistencia == null) return;

      axios
        .put(
          `/Sisa/Encuestas/Reenvio/${this.numeroAsistencia}`,
          {},
          configuracion
        )
        .then((res) => {
          this.listar();

          this.snackText = "Información Actualizada Correctamente!";
          this.snackColor = "primary";
          this.snack = true;
        })
        .catch((err) => {
          console.error(err);

          this.snackText = "No se pudo Actualizar la Información...";
          this.snackColor = "error";
          this.snack = true;
        })
        .finally(() => {
          this.numeroAsistencia = null;
          this.mostrarLinkWhatsapp = false;
        });
    },
    showReenvio(item) {
      const linkBase = process.env.VUE_APP_AXIOS;
      const linkEncuesta = `${linkBase}/Sisa/Encuesta/${item.idCabina}`;

      this.mostrarLinkWhatsapp = true;
      this.codigoSMS = "+503";
      this.numeroTelefono = item.numeroTelefono;
      this.numeroAsistencia = item.numeroAsistencia;

      this.mensajeLinkEncuesta = `${this.getSaludo()} tengo el gusto con ${item.titularPoliza.trim()}. \n`;
      this.mensajeLinkEncuesta += `Le saluda ${this.getNombreOperador()} de SISA asistencia; queremos hacerle un atento recordatorio a nuestra encuesta y agradecerle por utilizar nuestro servicio. Además, conocer su grado de satisfacción por medio de una breve encuesta por medio del siguiente link:`;
      this.mensajeLinkEncuesta += `\n\n ${linkEncuesta}`;
    },
    getNombreOperador() {
      const nombreUsuario = this.$store.state.usuario.nombre.trim();
      const splitNombre = nombreUsuario.split(" ");

      return splitNombre.length > 2
        ? `${splitNombre[0]} ${splitNombre[2]}`
        : nombreUsuario;
    },
    getSaludo() {
      const hora = new Date().getHours();

      if (hora >= 4 && hora < 12) {
        return "Buenos días,";
      } else if (hora >= 12 && hora < 18) {
        return "Buenas tardes,";
      } else {
        return "Buenas noches,";
      }
    },
    getFechaActual() {
      let today = new Date();
      let fechaGuardado =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      return fechaGuardado;
    },
    listar() {
      if (this.selectedCartera == "SISA SEGUROS") {
        this.listarSISA();
      } else {
        this.listarGeneral();
      }
    },
    listarSISA() {
      this.loader = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `/Sisa/Encuestas/NoCompletadas?inicio=${this.fechaInicio}&fin=${this.fechaFin}`,
          configuracion
        )
        .then((res) => {
          this.encuestasCompletadas = res.data.detallesCompletadas;
          this.encuestasSinCompletar = res.data.detallesSinCompletar;

          this.totalEncuestas = res.data.total;
          this.totalSinContestar = res.data.sinCompletar;
          this.totalContestadas = res.data.completadas;
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    listarGeneral() {
      this.loader = true;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "/Sisa/Encuestas/NoCompletadasGeneral",
          {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            cartera: this.selectedCartera,
          },
          configuracion
        )
        .then((res) => {
          this.encuestasCompletadas = res.data.detallesCompletadas;
          this.encuestasSinCompletar = res.data.detallesSinCompletar;

          this.totalEncuestas = res.data.total;
          this.totalSinContestar = res.data.sinCompletar;
          this.totalContestadas = res.data.completadas;
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    downloadReporteEncuestasCompletadas() {
      const data = XLSX.utils.json_to_sheet(this.encuestasCompletadas);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, data, "Encuestas");

      const filename = `Encuestas ${this.selectedCartera} ${this.fechaInicio} a ${this.fechaFin}.xlsx`;
      XLSX.writeFile(workbook, filename);
    },
    downloadReporteEncuestasNoCompletadas() {
      const data = XLSX.utils.json_to_sheet(this.encuestasSinCompletar);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, data, "Encuestas");

      const filename = `Encuestas ${this.selectedCartera} (Pendientes)${this.fechaInicio} a ${this.fechaFin}.xlsx`;
      XLSX.writeFile(workbook, filename);
    },
    downloadReporteEncuestasCompletadasSISA() {
      const listado = [];

      const formatData = this.encuestasCompletadas.map((encuesta) => ({
        numeroAsistencia: encuesta.cabinaId,
        Respuestas: encuesta.respuestas,
      }));

      formatData.forEach((encuesta) => {
        const totalPreguntas = encuesta.Respuestas.length;
        const totalPreguntasMalas = encuesta.Respuestas.filter(
          (res) => res.comentario != null && res.comentario != ""
        ).length;

        const minimoRequerido = totalPreguntas / 2;

        encuesta.Respuestas.forEach((respuesta, index) => {
          const textoResultados =
            totalPreguntasMalas >= minimoRequerido ? "Negativo" : "Positivo";

          listado.push({
            NumeroAsistencia: index == 0 ? encuesta.numeroAsistencia : "",
            Usuario: index == 0 ? respuesta.nombreUsuario : "",
            Resultados: index == 0 ? textoResultados : "",
            Preguntas: respuesta.pregunta,
            Respuestas: respuesta.respuesta,
            Comentario: !!respuesta.comentario ? respuesta.comentario : "",
            Fecha: !!respuesta.fecha ? respuesta.fecha.replace("T", " ") : "",
          });
        });

        listado.push({
          NumeroAsistencia: "",
          Usuario: "",
          Resultados: "",
          Preguntas: "",
          Respuestas: "",
          Comentario: "",
          Fecha: "",
        });
      });

      const data = XLSX.utils.json_to_sheet(listado);
      const workbook = XLSX.utils.book_new();

      data["!cols"] = [
        { wch: 17 },
        { wch: 12 },
        { wch: 17 },
        { wch: 60 },
        { wch: 20 },
        { wch: 60 },
        { wch: 17 },
      ];

      XLSX.utils.book_append_sheet(workbook, data, "Encuestas SISA");

      const filename = `Encuestas SISA ${this.fechaInicio} a ${this.fechaFin}.xlsx`;
      XLSX.writeFile(workbook, filename);
    },
    downloadReporteEncuestasNoCompletadasSISA() {
      const listado = this.encuestasSinCompletar.map((encuesta) => {
        return {
          NumeroAsistencia: encuesta.numeroAsistencia,
          TitularPoliza: encuesta.titularPoliza,
          Operador: encuesta.operador,
          NumeroTelefono: encuesta.numeroTelefono,
          Estado: this.getEstadoEncuesta(encuesta),
          Comentario: encuesta.motivoRechazo,
          TotalReenvios: encuesta.reenvios,
          UltimoEnvio: encuesta.ultimoEnvio,
          UltimoCambio: encuesta.ultimoCambio,
          ChangeBy: encuesta.ChangeBy,
        };
      });

      const data = XLSX.utils.json_to_sheet(listado);
      const workbook = XLSX.utils.book_new();

      data["!cols"] = [
        { wch: 15 },
        { wch: 35 },
        { wch: 35 },
        { wch: 15 },
        { wch: 15 },
        { wch: 60 },
        { wch: 12 },
        { wch: 12 },
        { wch: 12 },
        { wch: 12 },
      ];

      XLSX.utils.book_append_sheet(workbook, data, "Encuestas SISA");

      const filename = `Encuestas SISA (Pendientes)${this.fechaInicio} a ${this.fechaFin}.xlsx`;
      XLSX.writeFile(workbook, filename);
    },
  },
};
</script>
